import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=055153be&scoped=true"
import script from "./SvgIcon.vue?vue&type=script&lang=ts"
export * from "./SvgIcon.vue?vue&type=script&lang=ts"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=055153be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055153be",
  null
  
)

export default component.exports